import TermsAndCondition from "./registrationConditions/T&C.js";
import lang from "./lang.json";

export default {
    lang,
    registrationTerms: [
        {
            label: "條款及細則",
            html: TermsAndCondition
        }
    ]
};
